module.exports = __webpack_public_path__ + "static/media/hosp2.a2d18df7.jpg";